import React, { useState, useEffect, useCallback } from "react";
import {
  Page,
  Icon,
  Tooltip,
  EmptyState,
  Popover,
  ActionList,
  Badge,
  SkeletonBodyText,
  Pagination,
  TextField,
  Banner,
  Link,
  Button,
  Modal,
  TextContainer,
  Select,
  Layout,
  Card,
  Image,
  InlineStack,
  IndexTable,
  LegacyCard,
  Text,
  useIndexResourceState,
  FooterHelp,
} from "@shopify/polaris";
import SearchBar from "./common/SearchBar";
import axios from "axios";
import wrap from "word-wrap";

import { EditIcon, LinkIcon,InboundIcon } from "@shopify/polaris-icons";
import defaultInage from "../assets/image.jpg";
import { toast } from "react-toastify";
import ShopifyBag from "../assets/social.png";
import Ebay from "../assets/ebay.png";

import useIsMobile from "./useIsMobile";
import { FaLink } from "react-icons/fa6";
import { GrLink } from "react-icons/gr";
import Axios from "./common/Axios";
import { useLocation, useNavigate } from "react-router-dom";
import ProgressAnimation from "./common/ProgressAnimation";
import LoadingBar from "./common/Loading";

const UnLinked = () => {
  const location = useLocation();
  let error = location.state?.error;

  const [varifyError, setVerifyError] = useState([]);

  const [selectedProfile, setSelectedProfile] = useState("");
  const [last_page,setLastPage] = useState(1);
  const [showInfo,setShowInfo] = useState(true);
  const [resolveModel,setResolveModel] = useState(false);
  const [statusTab, setStatusTab] = useState("Unlinked");
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [resolveBanner,setResolveBanner] = useState('');
  const domain = process.env.REACT_APP_BASE_URL;
  const savedData = localStorage.getItem("storeData");
  const localData = savedData ? JSON.parse(savedData) : null;
  const [productData, setproductData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [upgradeModalActive, setUpgradeModalActive] = useState(false);
  const siteId = localData?.user?.eb_key[0]?.siteid ?? 0;

  const localProductCountData =  localStorage.getItem("productCount");
  const productCount = localProductCountData ? JSON.parse(localProductCountData) : null;
  const toggleUpgradeModal = () => setUpgradeModalActive((prev) => !prev);

  const toggleResolveModelModal = ()=>setResolveModel((prev) => !prev);

  const userData = localData.user;
  const shopurl = userData.shopurl;
  const storeName = shopurl.replace(".myshopify.com", "");

const [sh_pending_request, setShPendingRequest] = useState(
  userData?.sh_requests_pending ?? 2
);  
const [whichPage, setwhichPage] = useState("Unlinked");

  const [products, setProducts] = useState([]);
  const [productNotExists, setProductNotExists] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [firstProductNo, setFirstProductNo] = useState(0);
  const [lastProductNo, setLastProductNo] = useState(0);
  const [selectedVariants, setSelectedVariants] = useState([]);
  const [selectedListing, setSelectedListing] = useState([]);
  const [errorInfo, setErrorInfo] = useState([]);
  const [query, setQuery] = useState("");
  const [active, setActive] = useState(false);
  const [activeProfileModel, setActiveProfileModel] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [errorActive, setErrorActive] = useState(false);
const [errorToResolve,setErrorToResolve] = useState('');
  const [profiles, setProfiles] = useState([]);
  const [current_page, setCurrentPage] = useState(0);
  const [page, setPage] = useState(1);
  const [showAction, setShowAction] = useState(false);
  const [popoverActiveAction, setPopoverActiveAction] = useState(false);
  const [popoverActiveStatus, setPopoverActiveStatus] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [selectImportIds, setSelectedImport] = useState([]);
  const [selectReImportIds, setSelectedReImport] = useState([]);
  const [selectDeleteProductIds, setSelectedDeleteProduct] = useState([]);
  const [perPageValue, setPerPageValue] = useState("20");
  const [allProductId, setAllProductId] = useState([]);

  const [ whichErrorResolve , setWhichErrorResolve] =useState();
const [resolveArray, setResolveArray] = useState({  });
  const [importedProductCount, setImportedProductCount] = useState();
  const [reImportedProductCount, setReImportedProductCount] = useState(0);

  const addProductId = (newId) => {
    setAllProductId((prevState) => {
      // Check if newId already exists
      if (!prevState.includes(newId)) {
        return [...prevState, newId];
      }
      return prevState; // Return previous state unchanged if ID exists
    });
  };
  const [dimensionError, setDimensionError] = useState("");
  const toggleModal = useCallback(
    () => setActiveProfileModel((prev) => !prev),
    [],
  );
   const domainSite = {
        0: 'https://www.ebay.com',
        2: 'https://www.ebay.ca',
        3: 'https://www.ebay.co.uk',
        15: 'https://www.ebay.com.au',
        16: 'https://www.ebay.at',
        23: 'https://www.befr.ebay.be',
        71: 'https://www.ebay.fr',
        77: 'https://www.ebay.de',
        100: 'https://www.ebay.com',
        101: 'https://www.ebay.it',
        123: 'https://www.benl.ebay.be',
        146: 'https://www.ebay.nl',
        186: 'https://www.ebay.es',
        193: 'https://www.ebay.ch',
        201: 'https://www.ebay.com.hk',
        205: 'https://www.ebay.ie',
        207: 'https://www.ebay.com.my',
        210: 'https://www.cafr.ebay.ca',
        211: 'https://www.ebay.ph',
        212: 'https://www.ebay.pl',
        216: 'https://www.ebay.com.sg'
      };

const domainebay = domainSite[siteId];
  const validateDimensions = () => {
    const { height, width, length } = selectedListing.dimensions || {};

    //console.log(height, width, length);

    const isAnyFilled = height || width || length;
    const areAllFilled = height && width && length;

    if (isAnyFilled && !areAllFilled) {
      setDimensionError(
        "All dimensions (height, width, length) are required if any is filled.",
      );
      return false;
    }

    setDimensionError("");
    return true;
  };

  const getBadgeTone = (status) => {
    switch (status.toLowerCase()) {
      case "unlinked":
        return "info";
      case "error":
        return "critical";
      case "imported":
        return "success";
      default:
        return "attention";
    }
  };
  const Actionoptions = [
    {
      label: "Link Selected Products",
      value: "LSP",
      prefix: <FaLink style={{ fontSize: "1.2rem" }} />,
    },
    {
      label: "Link All Products",
      value: "LAP",
      prefix: <GrLink style={{ fontSize: "1.2rem" }} />,
    },
  ];
  const handleClose = () => setActive(false);
  const handleEditClose = () => setEditActive(false);
  const handleErrorClose = () => setErrorActive(false);

  const handleEditOpen = (Listing) => {
    setSelectedListing(Listing);
    setEditActive(true);
  };
  const handleErrorOpen = (error) => {
    setErrorInfo(error);
    setErrorActive(true);
  };

  const resourceName = {
    singular: "product",
    plural: "products",
  };
  const handleAllSelections = () => {
    alert("sadfasd");
    setShowAction(true);
    //console.log(selectedResources);
  };
function formatMessage(message) {
  if (!message) return "";
  const words = message.split(" ");
  return words.reduce((acc, word, index) => {
    acc += word + " ";
    if ((index + 1) % 6 === 0) acc += "\n";
    return acc;
  }, "").trim();
}
  const { selectedResources, allResourcesSelected, handleSelectionChange } =
    useIndexResourceState(products);

  const handleOpen = async (id) => {
    const response = await Axios.get("product/shopify/variants", {
      params: {
        id: id,
      },
    });
    setSelectedVariants(response.data);
    //console.log(response);

    setActive(true);
  };
  useEffect(() => {
    setIsLoading(true);

    const fetchUnlinked = async () => {
      try {
        const response = await Axios.get("product/shopify");
        if (response.data.total === 0) {
          setProductNotExists(true);
        } else {
          setProductNotExists(false);
        }
        setIsLoading(false);

        setproductData(true);
        setTotalPage(response.data.total);
        setFirstProductNo(response.data.from);
        setLastProductNo(response.data.to);
        setCurrentPage(response.data.current_page);
        setPerPageValue(response.data.per_page);
        setLastPage(response.data.last_page);

        const result = response.data;
        const formattedProducts = result.data.map((product) => {
          // Call addProductId with the product ID before returning the object
          addProductId(product.id);
          let imageUrl = "";
          const rawImage = product.image;

          try {
            if (
              typeof rawImage === "string" &&
              rawImage.trim().startsWith("[")
            ) {
              const parsed = JSON.parse(rawImage);
              if (Array.isArray(parsed)) {
                imageUrl = parsed[0]?.node?.url || "";
              }
            } else if (Array.isArray(rawImage)) {
              imageUrl = rawImage[0]?.node?.url || "";
            }
          } catch (err) {
            console.warn(
              `Invalid image JSON for product ID: ${product.id}`,
              err.message,
            );
          }
          return {
            Listing: product,
            id: product.id,
            title: product.edit_title
              ? wrap(product.edit_title, { width: 50 })
              : wrap(product.title, { width: 50 }),
            status: product.status,
            shopifyProductId: product.shopify_product_id,
            ebayItemId: product.ebayitemid ? product.ebayitemid : 0,
            image: imageUrl,
            error: JSON.parse(product.error_info),
            variants: product.has_variation ? product.has_variation : 0,
            variations: product.sh_product__variant
              ? product.sh_product__variant.map((variant) => ({
                  title: variant.title || "Default Option",
                  quantity: variant.quantity,
                  price: variant.price,
                  option1: variant.option1val || "-",
                  option2: variant.option2val || "-",
                  option3: variant.option3val || "-",
                }))
              : [],
          };
        });

        setProducts(formattedProducts);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchUnlinked();
  }, []);

  useEffect(() => {
    if (error) {
      setVerifyError(error);
      setErrorInfo(error);
      setErrorActive(true);
    }
  }, [error]);
  //console.log(errorInfo);
  //console.log(error);

  useEffect(() => {
    //console.log(errorActive);
    if (!errorActive) {
      navigate(location.pathname, {
        state: { ...location.state, error: null },
        replace: true,
      });
    }
  }, [errorActive]);

  //console.log("importedProductCount", importedProductCount);

  const handleLinkRequestSubmit = async (id) => {
    let toastId;
    try {
      //console.log(id);
      toastId = toast.loading("Linking product to eBay... Please wait....");
      const response = await Axios.put("product/shopify/linkedProductToEbay", {
        id: id,
      });
      //console.log(response);
      if (response.data.message) {
        toast.success(response.data?.message);
      }
      toast.dismiss(toastId);

      fetchUnlinked(query,current_page,perPageValue);
    } catch (error) {
      toast.dismiss(toastId);
    }
  };
  const handleImportRequestSubmit = async (id) => {
    try {


   
   if (userData.profileData.length === 0) {
        //console.log("profile not created");
        navigate(`${domain}/addprofile`, { state: { ids: [id] } });
        return;
      } else {
        if (!Array.isArray(id)) {
          const product = products.find((p) => p.id === id);
          if (product.variants === 1) {
            //  this for single variant import process
            const profileOptions = userData.profileData.map((profile) => ({
              label: profile.name,
              value: profile.id.toString(),
            }));
            setSelectedProfile(profileOptions[0].value);
            setSelectedId([id]);
            setProfiles(profileOptions);
            setActiveProfileModel(true);
          } else {
            const variantItems = userData.profileData.filter(
              (item) => item.is_variantions === 1,
            );
            if (variantItems.length === 0) {
              navigate(`${domain}/addprofile/`, {
                state: { ids: [id], multi_variation_check: true },
              });
            } else {
              const profileOptions = variantItems.map((profile) => ({
                label: profile.name,
                value: profile.id.toString(),
              }));
              setSelectedProfile(profileOptions[0].value);
              setSelectedId([id]);
              setProfiles(profileOptions);
              setActiveProfileModel(true);
            }
          }
        } else {
          const profileOptions = userData.profileData.map((profile) => ({
            label: profile.name,
            value: profile.id.toString(),
          }));
          setSelectedProfile(profileOptions[0].value);
          setSelectedId(id);
          setProfiles(profileOptions);
          setActiveProfileModel(true);
        }
      }
    } catch (error) {
      //console.log("error occur when linked product : ", error);
    }
  };

  const ComfirmProfileAndImport = async () => {
    setActiveProfileModel(false);
        const ids = Array.isArray(selectedId) ? selectedId : [selectedId];
      
      const totalSkuConsumed = userData.skuconsumed + ids.length;
     if (totalSkuConsumed >= userData.skulimit +1 ) {
          setUpgradeModalActive(true);
          return;
     }
     userData.skuconsumed = totalSkuConsumed;
     localData.user = userData;
   localStorage.setItem("storeData", JSON.stringify(localData));
    //console.log(selectedProfile);
    let toastId;
    toastId = toast.loading("Import verification in progress...");
    setProducts((prevProducts) =>
      prevProducts.map((product) => {
        const ids = Array.isArray(selectedId) ? selectedId : [selectedId];
        return ids.includes(product.id)
          ? { ...product, status: "progress" }
          : product;
      }),
    );
    try {
      const response1 = await Axios.put(
        `${process.env.REACT_APP_API_URL}/verifyEbayItem`,
        {
          profile_id: selectedProfile,
          product_id: selectedId[0],
        },
      );
      if (response1.data?.errorMassage && response1.data?.errorMassage.length > 0 ) {
        toast.update(toastId, {
          render: "Error occurs in Verification!",
          type: "error",
          isLoading: false,
          autoClose: 4000,
        });
      } else {
        toast.update(toastId, {
          render: "Verification successfully!",
          type: "success",
          isLoading: false,
          autoClose: 4000,
        });
       toastId = toast.loading("Import in progress...");
        const response = await Axios.put(
          `${process.env.REACT_APP_API_URL}/product/shopify/insertEbayImportRequest`,
          {
            id: selectedId,
            profile_id: selectedProfile,
          },
        );
        if (response.data.status === "404") {
          toast.error(response.data.message);
        }
        if (response.data?.errors) {
          toast.update(toastId, {
            render: "Error occurs in Import!",
            type: "error",
            isLoading: false,
            autoClose: 4000, // closes after 3 seconds
          });
            const error = response.data?.errors;
          let errors = [];
          error.forEach((item) => {
            errors.push(item);
          });
          setVerifyError(errors);
          setErrorInfo(errors);
          setErrorActive(true);
          // toast.success("Import Request Submited Successfully.");
        } else {
          if (selectedId.length > 1) {
                toast.update(toastId, {
                  render: "The import will complete after some time.",
                  type: "success",
                  isLoading: false,
                  autoClose: 4000, // closes after 3 seconds
                });
          }else{
            toast.update(toastId, {
              render: "Import completed successfully!",
              type: "success",
              isLoading: false,
              autoClose: 4000, // closes after 3 seconds
            });
          }
        }
      }

      fetchUnlinked(query,current_page,perPageValue);
    } catch (error) {
      if (error?.status === 406) {
        toast.dismiss(toastId);

        toast.error(error?.response?.data?.error?.msg[0]);
      }
    }
  };
  const handleActionChange = (value) => {
    //console.log(value);
  };
  const handleResolveUpdate =async ()=>{
    let toastId;
    toastId = toast.loading("updating....");
    try {
        const response = await Axios.put('/handleResolve', {
        toResolve: resolveArray
      });
      toast.dismiss(toastId);
      toast.success('Update Successfully.');
      fetchUnlinked(query,current_page,perPageValue);
    } catch (error) {
      console.log(error);
       toast.dismiss(toastId);
      
    }
    
  }

  const handlePerPage = (event) => {
    setPerPageValue(event.target.value);
    fetchUnlinked(query, current_page, event.target.value);
    //console.log(event.target.value);
  };
const fetchUnlinked = async (query, page = 1, perPage) => {
  setIsLoading(true);
  setproductData(false);
  setQuery(query);

  const params = {
    page,
    per_page: perPage,
    ...(query && { query }),
  };

  try {
    const { data } = await Axios.get("product/shopify", { params });

    const {
      total,
      from,
      to,
      current_page,
      per_page,
      last_page,
      data: products,
    } = data;

    // Group state updates to reduce re-renders
    setProductNotExists(total === 0);
    setTotalPage(total);
    setFirstProductNo(from);
    setLastProductNo(to);
    setCurrentPage(current_page);
    setPerPageValue(per_page);
    setLastPage(last_page);

    const formattedProducts = new Array(products.length);
    const productIds = [];

    for (let i = 0; i < products.length; i++) {
      const product = products[i];
      productIds.push(product.id);

      // Try parsing image quickly and safely
      let imageUrl = "";
      const rawImage = product.image;

      if (rawImage) {
        try {
          const parsed =
            typeof rawImage === "string" && rawImage.trim().startsWith("[")
              ? JSON.parse(rawImage)
              : rawImage;
          if (Array.isArray(parsed)) {
            imageUrl = parsed[0]?.node?.url || "";
          }
        } catch (err) {
          console.warn(`Invalid image JSON for product ID: ${product.id}`, err.message);
        }
      }

      formattedProducts[i] = {
        Listing: product,
        id: product.id,
        title: wrap(product.edit_title || product.title, { width: 50 }),
        status: product.status,
        image: imageUrl,
        shopifyProductId: product.shopify_product_id,
        ebayItemId: product.ebayitemid || 0,
        error: JSON.parse(product.error_info),
        variants: product.has_variation || 0,
        variations: Array.isArray(product.sh_product__variant)
          ? product.sh_product__variant.map((variant) => ({
              title: variant.title || "Default Option",
              quantity: variant.quantity,
              price: variant.price,
              option1: variant.option1val || "-",
              option2: variant.option2val || "-",
              option3: variant.option3val || "-",
            }))
          : [],
      };
    }

    // Batch update product IDs only once
    productIds.forEach(addProductId);

    setProducts(formattedProducts);
    setproductData(true);
  } catch (error) {
    console.error("Error fetching products:", error);
  } finally {
    setIsLoading(false);
  }
};

  const handleSelectChange = (value) => {
    setSelectedProfile(value);
  };

  const handleSaveEditDetails = async () => {
    try {
      const response = await Axios.put(
        `${process.env.REACT_APP_API_URL}/product/shopify/saveEdit`,
        {
          product: selectedListing,
        },
      );
      setEditActive(false);
      //console.log(response.data);
      toast.success(response.data.message);
      fetchUnlinked(query);
    } catch (error) {
      //console.log(error);
    }

    //console.log(selectedListing);
  };

  const handleredirect = () => {
    window.location.href = `https://www.ebay.com/itm/2313235`;
  };
  const fetchShopifyProduct = async () => {
    try {
      setShPendingRequest(1);
      const response = await Axios.put(
        `${process.env.REACT_APP_API_URL}/product/shopify/fetchShopifyProducts`,
      );
      toast.success(response.data.message);
    } catch (error) {
      if (error.status === 406) {
        toast.error(error.response.data.error.msg[0]);
      }
      //console.log(error);
    }
  };
  const handleSelectedProduct = (value) => {
    handleImportRequestSubmit(selectedResources);
    // alert(selectedResources);
  };

  const handleSelectedAllProduct = (value) => {
    handleImportRequestSubmit(allProductId);
    // alert(allProductId);
  };
  const handleSelectItem = (id) => {
    //console.log("Selected ID:", id);
  };

  const conditionOnResolve = (error)=>{
    if (error == 'Quantity is not valid.') {
      return true;
    }else if(error == 'Description is missing.'){
      return true;
    }else{
      return false
    }
  } 
  const handleErrorRosolve = (error,sh_product_id)=>{
    //console.log("handleErrorRosolve",error);
    setResolveArray({ ...resolveArray, sh_product_id: sh_product_id })
    if (error.shortmessage == 'Quantity is not valid.') {
      setResolveModel(true);
      setResolveBanner('The quantity must be a valid number greater than 0. Please update the product listing to include a valid quantity before proceeding.');
      setErrorToResolve(error);
      setWhichErrorResolve('Quantity');
    }
    if (error.shortmessage == 'Description is missing.') {
      setResolveModel(true);
      setResolveBanner('A description is required. please enter description for import product to ebay.');
      setErrorToResolve(error);
      setWhichErrorResolve('Description');
    }

  }

  const rowMarkup = products.map(
    (
      {
        id,
        title,
        status,
        image,
        variants,
        variations,
        Listing,
        error,
        shopifyProductId,
        ebayItemId,
      },
      index,
    ) => (
      <IndexTable.Row
        id={id}
        key={id}
        selected={selectedResources.includes(id)}
        onClick={() => handleSelectItem(id)}
      >
        <IndexTable.Cell selectable={false}>
          {image ? (
            <img src={image} width="50" height="50" className="iamgeProduct" />
          ) : (
            <Image
              src={defaultInage}
              width="50"
              height="50"
              borderRadius="8px"
            />
          )}
        </IndexTable.Cell>
        <IndexTable.Cell width="500px">
          <Tooltip content="Click here to edit product.">
            <div
              style={{
                display: "ruby-text",
                alignItems: "center",
                gap: "4px",
                flexWrap: "nowrap",
              }}
            >
              {isMobile ? (
                <span
                  className="responsive-title"
                  style={{ fontFamily: '"Gill Sans", sans-serif' }}
                >
                  {title.split("\n").map((line, idx) => (
                    <React.Fragment key={idx}>
                      {line}
                      {idx !== title.split("\n").length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </span>
              ) : (
                <Link
                  onClick={() => handleEditOpen(Listing)}
                  monochrome
                  removeUnderline={true}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    whiteSpace: "pre-line",
                    textDecoration: "none",
                  }}
                >
                  <Text as="p" fontWeight="medium">
                    {title.split("\n").map((line, idx) => (
                      <React.Fragment key={idx}>
                        {line}
                        {idx !== title.split("\n").length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </Text>
                </Link>
              )}
            </div>
          </Tooltip>
          {isMobile && (
            <>
              <Text as="p">Variants: {variants}</Text>
              <Badge tone={getBadgeTone(status)}>{status}</Badge>
              <IndexTable.Cell>
                {status === "Unlinked" && (
                  <Button
                    variant="primary"
                    onClick={() => handleImportRequestSubmit(id)}
                  >
                    Import On Ebay
                  </Button>
                )}
              </IndexTable.Cell>
            </>
          )}
        </IndexTable.Cell>
        {!isMobile && (
          <>
            <IndexTable.Cell>
 {status === "progress" ? (
  <ProgressAnimation />
) : status === "error" ? (
  Array.isArray(error) && error.length > 0 ? (
    <div style={{ padding: "8px 0" }}>
      {error.map((err, index) => (
        <div key={index} style={{ marginBottom: "10px" }}>
          <span style={{ color: "#8B0000", fontWeight: "bold" }}>
            <img
              src="https://cdn-icons-png.flaticon.com/512/564/564619.png"
              alt="error"
              width="12"
              height="12"
              style={{ marginRight: "6px", verticalAlign: "middle" }}
            />
            eBay Error:
          </span>{" "}
          <span style={{ color: "#8B0000" }}>
            {formatMessage(err.shortmessage || "No error message available")}
          </span>
          <div>
            { conditionOnResolve(err?.shortmessage || "Default message") &&(

                <a 
                  href="#"
                  style={{
                    color: "#0046be",
                    fontWeight: "500",
                    fontSize: "14px",
                    textDecoration: "underline",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleErrorRosolve(err,id);
                  }}
                >
                  Resolve
                </a>
            )
            }
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div style={{ color: "#8B0000" }}>
      <strong>eBay Error:</strong> No error details available
    </div>
  )
) : (
  <Badge tone={getBadgeTone(status)}>{status}</Badge>
)}


              
            </IndexTable.Cell>
            <IndexTable.Cell>
              <Tooltip content="View variants">
                <div className="">
                  <Link
                    monochrome
                    removeUnderline
                    onClick={() => handleOpen(id)}
                  >
                    {variants} variants
                  </Link>
                </div>
              </Tooltip>
            </IndexTable.Cell>
            <IndexTable.Cell>
              <Tooltip content="View on shopify" preferredPosition="below">
                <a
                  href={`https://admin.shopify.com/store/${storeName}/products/${shopifyProductId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  className="shopify-link"
                >
                  <img
                    src={`https://cp2.infoshoreapps.com/cp/assets/shopify.png`}
                    width="40"
                    height="40"
                    alt="Shopify Product"
                  />
                </a>
              </Tooltip>
              <Tooltip content="View on Ebay" preferredPosition="below">
                {ebayItemId != 0 && (
                  <a
                    href={`${domainebay}/itm/${ebayItemId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <img
                      src={`https://cp2.infoshoreapps.com/cp/assets/ebay.png`}
                      width="50"
                      height="25"
                      alt="Shopify Product"
                    />
                  </a>
                )}
              </Tooltip>
            </IndexTable.Cell>
            <IndexTable.Cell>
              <div style={{ display: "flex", gap: "8px" }}>
                <Tooltip content="Import product on ebay ">
                  {status === "Unlinked" && (
                    <Button
                      variant="primary"
                      onClick={() => handleImportRequestSubmit(id)}
                    >
                      Import On Ebay
                    </Button>
                  )}
                   {status === "Imported" && (
                    <Button
                      variant="primary"
                      onClick={() => handleImportRequestSubmit(id)}
                    >
                      Revise
                    </Button>
                  )}
                </Tooltip>
              </div>
            </IndexTable.Cell>
          </>
        )}
      </IndexTable.Row>
    ),
  );
  const handleDimensionChange = (field, value) => {
    //console.log("helloo");

    //console.log(field, value);

    const updatedDimensions = {
      ...selectedListing.dimensions,
      [field]: value,
    };
    setSelectedListing((prev) => ({
      ...prev,
      dimensions: {
        ...prev.dimensions,
        [field]: value,
      },
    }));

    // Validate if all fields are filled
    const allFilled = ["height", "width", "length"].every(
      (f) => updatedDimensions[f] && updatedDimensions[f] !== "",
    );

    setDimensionError(allFilled ? "" : "All dimensions must be filled.");
  };

  const togglePopoverActiveStatus = useCallback(
    () => setPopoverActiveStatus((active) => !active),
    [],
  );
  const togglePopoverActiveAction = useCallback(
    () => setPopoverActiveAction((active) => !active),
    [],
  );

  const activatorAction = (
    <Button onClick={togglePopoverActiveAction} disclosure>
      Action
    </Button>
  );
  const handleSelectionChangeWrapper = (selectedResources, selectionType) => {
    handleSelectionChange(selectedResources, selectionType); // Default selection handler
    performAdditionalAction(selectedResources); // Custom function for extra actions
  };

  const performAdditionalAction = (selectedResources) => {
 
    // You can trigger API calls, state updates, etc.
  };
  useEffect(() => {
    if (Array.isArray(selectedResources) && selectedResources.length > 0) {
      if (localData.user.plan === 0) {
        if (selectedResources.length > 5) {
          //console.log(selectedResources);
        }
      }
      const filteredProductIds = products
        .filter(
          (product) =>
            selectedResources.includes(product.id) &&
            product.status === "Unlinked",
        )
        .map((product) => product.id); // Get only the IDs of the filtered products
      if (localData.user.plan === 0) {
        if (localData.user.skuconsumed >= localData.user.skulimit) {
          setUpgradeModalActive(true);
        } else {
       
          const importIds = filteredProductIds.slice(
            0,
            localData.user.skulimit - localData.user.skuconsumed,
          );
          setSelectedImport(importIds);
          setImportedProductCount(importIds.length);
        }
      } else {
        setSelectedImport(filteredProductIds);
        setImportedProductCount(filteredProductIds.length);
      }
      //console.log(filteredProductIds);
      //console.log(filteredProductIds.length);
      const filteredReProductIds = products
        .filter(
          (product) =>
            selectedResources.includes(product.id) &&
            product.status === "Imported",
        )
        .map((product) => product.id); 
      setSelectedReImport(filteredReProductIds);
      setSelectedDeleteProduct(filteredReProductIds);
      setReImportedProductCount(filteredReProductIds.length);
    } else {
      setImportedProductCount(0);
    }
  }, [selectedResources, products]);
const promotedBulkActions = [
  importedProductCount > 0 && {
    content: `Import ${importedProductCount} Selected Products`,
    onAction: () => {
      if (importedProductCount > 0) {
        handleImportRequestSubmit(selectImportIds);
      }
    },
  },
  reImportedProductCount > 0 && {
    content: `Reimport ${reImportedProductCount} Selected Products`,
    onAction: () => {
      if (reImportedProductCount > 0) {
        handleImportRequestSubmit(selectReImportIds);
      }
    },
  },
  (userData.plan > 0 && importedProductCount > 0) && {
    title: 'Action',
    actions: [
      {
        icon: LinkIcon,
        content: 'Link Selected Product',
        onAction: () => handleLinkRequestSubmit(selectImportIds),
      },
    ]
  }
].filter(Boolean);

  let content;
  useEffect(() => {
    if (selectedResources.length > 0) {
      setShowAction(true);
    } else {
      setShowAction(false);
    }
  }, [selectedResources]);

  if (!productData) {
    content = (
      <Card>
        <LegacyCard subdued>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
        </LegacyCard>
        <LegacyCard subdued>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
        </LegacyCard>
        <LegacyCard subdued>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
        </LegacyCard>
        <LegacyCard subdued>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
        </LegacyCard>
      </Card>
    );
  } else if (products.length === 0) {
    if (productCount?.shproducts == 0) {
      content = (
        <Card>
          {" "}
          <EmptyState
            heading="No Product Found On Shopify"
            action={{
              content: "Create Shopify Product",
              url: `https://admin.shopify.com/store/${storeName}/products/new`,
              target: "_blank",
            }}
            image="https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/empty-state-personalized-Bu4xlcHV0rQu.svg"
            fullWidth
          >
            <Text variant="bodyLg" as="p">
              You currently have no products available in your <strong>Shopify store.</strong> 
              Please create a product to continue.
            </Text>
          </EmptyState>
        </Card>
      );
    } else {
      content = (
        <Card>
          <EmptyState
            heading="No Product Found On Shopify"
            image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
            fullWidth
          ></EmptyState>
        </Card>
      );
    }
  } else {
    content = (
      <IndexTable
        selectable
        resourceName={resourceName}
        itemCount={products.length}
        selectedItemsCount={
          allResourcesSelected ? "All" : selectedResources.length
        }
        onSelectionChange={handleSelectionChange}
        promotedBulkActions={promotedBulkActions}
        headings={[
          {
            title: (
              <h2 style={{ fontSize: "1.1em", fontWeight: "700" }}>Image</h2>
            ),
          },
          {
            title: (
              <h2 style={{ fontSize: "1.1em", fontWeight: "700" }}>Title</h2>
            ),
          },
          {
            title: (
              <h2 style={{ fontSize: "1.1em", fontWeight: "700" }}>Status</h2>
            ),
          },
          {
            title: (
              <h2 style={{ fontSize: "1.1em", fontWeight: "700" }}>Variants</h2>
            ),
          },
          {
            title: (
              <h2 style={{ fontSize: "1.1em", fontWeight: "700" }}>Open In</h2>
            ),
          },
          {
            title: (
              <h2 style={{ fontSize: "1.1em", fontWeight: "700" }}>Actions</h2>
            ),
          },
        ]}
      >
        {rowMarkup}
      </IndexTable>
    );
  }

  return (
    <Page
      fullWidth
      title="Shopify Products"
      className="product-list"
      primaryAction={{
        content: "Fetch Shopify Products",
        onAction: fetchShopifyProduct,
        helpText: "Fetch Products From Your Shopify Store.",
        primary: true,
        icon: InboundIcon,
      }}
    >
      <div style={{ width: "100%", marginRight: "20px", marginBottom: "40px" }}>
        <Layout>
          <Layout.Section>
            <div style={{ width: "100%", marginRight: "20px", marginBottom: "20px" }}>
                  {showInfo && (
                          <Banner onDismiss={() => setShowInfo(false)}>
                          <Text as="p" fontWeight="medium">
                            Here you can view the products from your shopify store and easily import them into your eBay store.
                          </Text>
                        </Banner>
                    )}

              {
                sh_pending_request == 1 && (
                      <Banner onDismiss={() => {setShPendingRequest(0)}}>
                      <Text as="p" fontWeight="medium">
                        We are currently fetching the products from Shopify Store, and the process will be completed soon.Import 5 products for FREE and start selling faster.
                      </Text>
                      </Banner>
                )
              }
              {
                sh_pending_request == 2 && productCount.shproducts > 0  && (
                    <Banner onDismiss={() => {setShPendingRequest(0)}}>
                         <Text as="p" fontWeight="medium">
                      The product fetch process is complete. 
                      </Text>
                  </Banner>
                )
              }
              {productCount.shproducts == 0 && sh_pending_request == '2' &&(
                            <Banner >
                              <Text as="p" fontWeight="medium">
                                Fetch completed, but no products were found in your <strong>Shopify Store.</strong> Please ensure your products are added and available on shopify in active state
                              </Text>
                            </Banner>
                          )}
            
            </div>
            <>
              {isMobile && (
                <>
                  <SearchBar
                    fetchproduct={fetchUnlinked}
                    whichPage={whichPage}
                  />

                  {content}
                </>
              )}
              {!isMobile && (
                <>
                  <SearchBar
                    fetchproduct={fetchUnlinked}
                    whichPage={whichPage}
                  />

                  {content}
                </>
              )}
            </>

            <Modal
              open={active}
              onClose={handleClose}
              title="Product Variation List"
              primaryAction={{ content: "Close", onAction: handleClose }}
            >
              <Modal.Section>
                {selectedVariants.length > 0 ? (
                  <table className="Polaris-Table variant-table">
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>Sku</th>
                        <th>Quantity</th>
                        <th>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedVariants.map((variant, index) => (
                        <tr key={index}>
                          <td>{variant.title}</td>
                          <td>{variant.sku}</td>
                          <td>{variant.quantity}</td>
                          <td>{variant.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <Text>No Variants Available</Text>
                )}
              </Modal.Section>
            </Modal>
            <Modal
                open={upgradeModalActive}
                onClose={toggleUpgradeModal}
                title="Upgrade Required"
                primaryAction={{
                  content: 'Upgrade Plan',
                  onAction: () => {
                    window.open(`${process.env.REACT_APP_BASE_URL}/Plan&Pricing`)
                  },
                }}
                secondaryActions={[
                  {
                    content: 'Cancel',
                    onAction: toggleUpgradeModal,
                  },
                ]}
              >
                <Modal.Section>
                  <TextContainer>
                    <p>
                      You have reached your import limit. Please upgrade your plan to import more products.
                    </p>
                  </TextContainer>
                </Modal.Section>
              </Modal>
                  <Modal
                open={resolveModel}
                onClose={toggleResolveModelModal}
                title={`Resolving : ${errorToResolve.shortmessage}`}
                primaryAction={{
                  content: 'Update',
                  onAction: () => {
                    setResolveModel(false);
                    handleResolveUpdate();
                  },
                }}
                secondaryActions={[
                  {
                    content: 'Cancel',
                    onAction: toggleResolveModelModal,
                  },
                ]}
              >
                <Modal.Section>
                     <Card>
                  <Banner onDismiss={() => {}} tone="warning">
                    <p>
                      {resolveBanner}
                    </p>
                  </Banner>
                      {whichErrorResolve==='Quantity' &&(
                        <TextField
                            label="Quantity*"
                            type="number"
                            value={resolveArray.quantity || ""}
                            autoComplete="off"
                            onChange={(value) =>
                              setResolveArray({ ...resolveArray, quantity: value })
                            }
                          />
                      )}
                         {whichErrorResolve==='Description' &&(
                        <TextField
                            label="Description*"
                            value={resolveArray.description || ""}
                            autoComplete="off"
                            onChange={(value) =>
                              setResolveArray({ ...resolveArray, description: value })
                            }
                          />
                      )}

                  </Card>
                </Modal.Section>
              </Modal>
            <Modal
              open={errorActive}
              onClose={handleErrorClose}
              title="Error"
              primaryAction={{ content: "Close", onAction: handleErrorClose }}
            >
              <Modal.Section>
                {(() => {
                  let parsedErrors;

                  try {
                    parsedErrors = Array.isArray(errorInfo)
                      ? errorInfo
                      : JSON.parse(errorInfo);
                  } catch (e) {
                    parsedErrors = [];
                  }

                  return Array.isArray(parsedErrors) ? (
                    parsedErrors.map((item, index) => (
                      <p key={index} style={{ color: "red" }}>
                        {item.longmessage || "Unknown error"}
                      </p>
                    ))
                  ) : (
                    <p style={{ color: "red" }}>Invalid error format</p>
                  );
                })()}
              </Modal.Section>

            </Modal>
            <Modal
              open={activeProfileModel}
              onClose={toggleModal}
              title="Choose a profile for import"
              primaryAction={{
                content: "Confirm",
                onAction: ComfirmProfileAndImport,
              }}
              secondaryActions={[
                {
                  content: "Create New Profile",

                  onAction: () =>
                    navigate(`${domain}/addprofile`, {
                      state: { ids: selectedId },
                    }),
                },
              ]}
            >
              <Modal.Section>
                <TextContainer>
                  <Select
                    label="Profiles"
                    options={profiles}
                    onChange={handleSelectChange}
                    value={selectedProfile}
                  />
                </TextContainer>
              </Modal.Section>
            </Modal>
            <Modal
              open={editActive}
              onClose={handleEditClose}
              title="Edit Product"
              primaryAction={{
                content: "Save",
                onAction: handleSaveEditDetails,
                disabled: !!dimensionError, // Disable if there's an error
              }}
              secondaryActions={[
                {
                  content: "Cancel",
                  onAction: handleEditClose,
                },
              ]}
            >
              <Modal.Section>
                <Card>
                  <Banner onDismiss={() => {}} tone="warning">
                    <p>
                      Don't fill the field if you don't want to update the
                      product
                    </p>
                  </Banner>
                  {dimensionError && (
                    <Banner
                      status="critical"
                      title="Validation Error"
                      onDismiss={() => setDimensionError("")}
                    >
                      <p>{dimensionError}</p>
                    </Banner>
                  )}

                  {/* Editable Title */}
                  <TextField
                    label="Title"
                    value={selectedListing.title || ""}
                    onChange={(value) =>
                      setSelectedListing({ ...selectedListing, title: value })
                    }
                    autoComplete="off"
                  />

                  <TextField
                    label="Height (cm)"
                    type="number"
                    value={selectedListing.dimensions?.height || ""}
                    onChange={(value) => handleDimensionChange("height", value)}
                    autoComplete="off"
                  />

                  <TextField
                    label="Width (cm)"
                    type="number"
                    value={selectedListing.dimensions?.width || ""}
                    onChange={(value) => handleDimensionChange("width", value)}
                    autoComplete="off"
                  />

                  <TextField
                    label="Length (cm)"
                    type="number"
                    value={selectedListing.dimensions?.length || ""}
                    onChange={(value) => handleDimensionChange("length", value)}
                    autoComplete="off"
                  />
                </Card>
              </Modal.Section>
            </Modal>

            {/* </IndexTable> */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#f6f6f7",
                padding: "10px 16px",
                borderTop: "1px solid #dfe3e8",
                borderBottom: "1px solid #dfe3e8",
              }}
            >
              {/* Pagination controls */}
              <Pagination
                onPrevious={() => {
                  fetchUnlinked(query, current_page - 1, perPageValue);
                }}
                onNext={() => {
                  fetchUnlinked(query, current_page + 1, perPageValue);
                }}
                hasPrevious={current_page !== 1}
                hasNext={current_page !== last_page}
                type="table"
                label={`${firstProductNo}-${lastProductNo} of ${totalPage} products`}
              />

              {/* Dropdown for per page selection */}
              <select
                name="perPageSelect"
                style={{
                  height: "32px",
                  padding: "4px 8px",
                  fontSize: "14px",
                  border: "1px solid #dfe3e8",
                  borderRadius: "4px",
                  backgroundColor: "#f6f6f7",
                  color: "#000",
                  appearance: "none",
                  backgroundImage: `url("data:image/svg+xml;utf8,<svg fill='black' height='12' viewBox='0 0 24 24' width='12' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>")`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 8px center",
                  backgroundSize: "12px",
                  paddingRight: "24px",
                  cursor: "pointer",
                }}
                value={perPageValue}
                onChange={handlePerPage}
              >
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </Layout.Section>
        </Layout>
      </div>
    </Page>
  );
};

export default UnLinked;
